/* global rwgps */
import cx from "classnames";
import { UserCard } from "common/hovercards/UserCard";
import { Icon } from "common/Icon";
import { Card } from "common/styleguide/Card";
import { Distance, Elevation } from "common/units";
import { commonMessages, commonNouns, Msg, privacyLevels, useFormatMessage } from "lib/localization";
import { missingPhoto } from "lib/photoUtils";
import { urls } from "lib/urls";
import _ from "lodash";
import React from "react";
import { Link, withRouter } from "react-router-dom";
import styles from "./CollectionCard.scss";

const visibilityMessage = (level) => {
  switch (level) {
    case 0:
      return privacyLevels.public;
    case 1:
      return privacyLevels.managers;
    case 2:
      return privacyLevels.members;
    default:
      console.warn(`Unexpected privacy level ${level}`);
  }
};

export const CollectionCard = withRouter(({ collection: c, currentUser, isMobile, history }) => {
  const fm = useFormatMessage();
  // don't allow clicks on user link to bubble
  const userLink = (e) => {
    e.preventDefault();
    history.push(c.bylinePath);
  };

  return (
    <Card noPadding className={cx(styles.CollectionCard, isMobile && styles.collapsed)}>
      <Link to={urls.collections.show(c.id, c.privacyCode)}>
        <div className={styles.top}>
          {missingPhoto(c.cover) ? <Icon size={40} i="dynamic-feed" /> : <img height="160" src={c.cover} />}
        </div>
        <div className={styles.bottom}>
          <h3>{c.title}</h3>
          <div className={styles.stats}>
            <div className={styles.distanceElevation}>
              <span>
                <Distance bigUnits short value={_.get(c, "stats.distance")} />
              </span>
              <span>
                <Elevation short value={_.get(c, "stats.elevation")} />
              </span>
            </div>
            <div className={styles.itemsUser}>
              <div className={styles.numItems}>
                {c.stats.items} <Msg m={commonNouns.items} values={{ count: c.stats.items }} />
              </div>
              {c.userId !== currentUser.id && (
                <UserCard id={c.userId}>
                  <a onClick={userLink} className={styles.owner}>
                    <Msg m={commonMessages.byline} values={{ author: c.bylineName }} />
                  </a>
                </UserCard>
              )}
              {c.userId === currentUser.id && rwgps.config.club?.id && <div>{fm(visibilityMessage(c.visibility))}</div>}
            </div>
          </div>
        </div>
      </Link>
    </Card>
  );
});
